<mat-icon class="bell" [ngStyle]="semaphoreCargoTime" matTooltip="Mas de {{timeLastLocation}} sin reportar novedades"
    matTooltipPosition="right">notifications_active
</mat-icon>